String.prototype.getDateFromMicrosoftJsonFormatted = function () {
    return new Date(Number.parseInt(this.match('\\d{5,}')![0]))
}
